
import React from 'react'
import { FiPlay, FiRefreshCw } from 'react-icons/fi'

import style from './Control.module.scss'
import { selectContent } from '~utils/analytics'

const RunButton = ({
  explorer,
  microcopy
}) => {
  const onClick = () => {
    explorer.execute()
    selectContent('API Explorer - Execute')
  }

  return (
    <>
      { explorer.accessToken.loggedIn() && (
        <button 
          className={style.run}
          data-valid={explorer.valid}
          data-executing={explorer.executing}
          data-logged-in={explorer.accessToken.loggedIn()}
          onClick={onClick}
        >
          { microcopy.text('explorer.buttons.run') }
          { explorer.executing ? <FiRefreshCw/> : <FiPlay/> }
        </button>
      )}
    </>
  )
}

export default RunButton